import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

export default function Header({ darkMode, currentSection, scrollToSection, setDarkMode, mobileMenuOpen, setMobileMenuOpen }) {
  return (
    <>
      <DesktopNav
        darkMode={darkMode}
        currentSection={currentSection}
        scrollToSection={scrollToSection}
        setDarkMode={setDarkMode}
      />
      <MobileNav
        darkMode={darkMode}
        currentSection={currentSection}
        scrollToSection={scrollToSection}
        setDarkMode={setDarkMode}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
    </>
  );
}